module.exports = __webpack_public_path__ + "img/guidePage2.ca959e43.png";